import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React from "react";
import { IoMdClose } from "react-icons/io";

const CostModal = ({ isOpen, onClose, detailsInfo }) => {
  // Calculate Total
  const totalAmount = detailsInfo?.coasting_details?.reduce(
    (sum, item) => sum + item.amount,
    0
  );

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={() => {
          onClose();
        }}
        className="relative z-50"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-2 sm:p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg mx-2 sm:mx-0 max-w-[95vw] sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-3 sm:px-4 pb-4 sm:pb-6 pt-2 sm:pt-3">
                <div className="flex justify-between items-center mb-3 sm:mb-4">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    Cost
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="text-gray-600 hover:text-gray-800 p-1"
                  >
                    <IoMdClose className="text-2xl font-light" />
                  </button>
                </div>
                {/* Body */}
                <div className="py-4 space-y-3">
                  {detailsInfo?.coasting_details &&
                    detailsInfo?.coasting_details?.map((res, index) => {
                      return (
                        <div
                          className="flex justify-between text-gray-600"
                          key={index}
                        >
                          <span>{res?.title}</span>
                          <span className="text-black font-medium">
                            ${res?.amount}
                          </span>
                        </div>
                      );
                    })}

                  {/* Total */}
                  <div className="flex justify-between text-lg font-bold text-[#284184] border-t pt-2">
                    <span>Total</span>
                    <span className="text-[#284184]">${totalAmount}</span>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default CostModal;
